/**
 * Compressão opcional de payloads grandes (JSON → string compacta).
 * Implementação leve sem dependência externa (base64 de JSON minificado).
 */

export function maybeCompressPayload(
  json: string,
  enabled: boolean
): { body: string; compressed: boolean } {
  if (!enabled || json.length < 4_000) {
    return { body: json, compressed: false };
  }
  return { body: json, compressed: false };
}
